<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑子账号"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}" autocomplete="off">
            <el-form-item label="子账号姓名" prop="user_name">
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入子账号姓名" maxlength="5" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="登录手机号码" prop="mobile">
                <el-input type="text" v-model="ruleForm.mobile" maxlength="11" placeholder="请输入登录手机号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="关联特属服务对象" prop="client_id">
                <el-autocomplete class="user_search"
                                 v-model="ruleForm.user_info"
                                 :fetch-suggestions="getUser"
                                 placeholder="请输入内容"
                                 @select="userSelect"
                                 @blur="resetUserInfo"
                ></el-autocomplete>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="头像">
                <div class="avatar-uploader">
                    <label class="avatar-btn" for="uploads">
                        <img style=" width: 200px;height: 200px;" v-if="userAvaratImageUrl" :src="userAvaratImageUrl"
                             class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </label>
                </div>
                <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
            </el-form-item>


            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="头像裁剪" :visible.sync="dialogVisible" append-to-body @close="closeDialog">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :autoCrop="true"
                        :fixed="true"
                        :fixedNumber="[1, 1]">
                    </vue-cropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <label class="el-button el-button--primary" for="suploads" style="margin-right: 10px;"><span>重新选择</span></label>
                <input type="file" id="suploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                <el-button type="primary" @click="uploadImg('blob')" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {VueCropper} from "vue-cropper";
import {isMobile} from "@/api/order";

export default {
    components: {
        VueCropper
    },
    created() {
        if (isMobile()) {
            this.form_width = "100%"
        }
        localStorage.setItem('prev_page', 'assistant_edit')
        if (this.$route.query.user_id) {
            this.user_id = this.$route.query.user_id;
            this.getDetail()
        } else {
            this.user_id = this.$route.params.user_id;
            this.ruleForm.user_name = this.$route.params.user_name;
            this.old_user_name = this.ruleForm.user_info = this.$route.params.client_user_name;
            this.ruleForm.mobile = this.$route.params.mobile;
            this.ruleForm.client_id = this.$route.params.client_id;
            this.ruleForm.status = parseInt(this.$route.params.status);
            this.ruleForm.user_avatar = this.$route.params.user_avatar;
            if (this.$route.params.user_avatar) {
                this.userAvaratImageUrl = this.imgUrl + this.$route.params.user_avatar;
            }
        }

    },
    mounted() {
        this.createParams();
    },
    data() {
        return {
            search_key: '',// 特属服务对象输入临时存储
            user_id: '',
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            userAvaratImageUrl: '',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            allClientUSer: [],
            old_user_name: '',
            ruleForm: {
                user_name: "",
                mobile: "",
                client_id: "",
                status: 1,
                is_main: 1,
                user_avatar: "",
                user_info: "",// 特属服务对象姓名信息
            },
            rules: {
                user_name: [
                    {required: true, message: "请输入特属服务对象姓名", trigger: "blur"},
                ],
                mobile: [
                    {required: true, message: "请输入手机号码", trigger: "blur"},
                ],
                client_id: [
                    {required: true, message: "请选择关联特属服务对象", trigger: "blur"},
                ],
                status: [
                    {required: true, message: "请选择状态", trigger: "blur"},
                ],

            },
            dialogVisible: false,
            // 防止重复提交
            loading: false,
            option: {
                img: '',             //裁剪图片的地址
            },
            is_submit: false,
            form_width: "40%",
        };
    },
    methods: {
        // 子账号关联特属服务对象
        createParams() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'createUserAssistanClientUser',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allClientUSer = res.data.data;
            });
        },
        getDetail() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'userAssistantDetail',
                params: {
                    user_id: this.user_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                this.user_id = res.data.data.user_id;
                this.ruleForm.user_name = res.data.data.user_name;
                this.old_user_name = this.ruleForm.user_info = `${res.data.data.bloc_name}/${res.data.data.client_user_name}`; // 关联特属服务对象
                this.ruleForm.mobile = res.data.data.user_mobile;
                this.ruleForm.client_id = res.data.data.client_user_id;
                this.ruleForm.status = parseInt(res.data.data.status);
                this.ruleForm.user_avatar = res.data.data.user_avatar;
                if (res.data.data.user_avatar) {
                    this.userAvaratImageUrl = this.imgUrl + res.data.data.user_avatar;
                }
            });
        },
        // 返回上一页
        goBack() {
            if (this.$route.query.user_id) {
                window.close()
            } else {
                window.history.go(-1);
            }
        },

        // 提交表单
        submitForm(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AdminCustomerServices',
                        'method': 'editUserAssistant',
                        'params': {
                            user_id: this.user_id,
                            client_id: this.ruleForm.client_id,
                            user_name: this.ruleForm.user_name,
                            mobile: this.ruleForm.mobile,
                            status: this.ruleForm.status,
                            is_main: this.ruleForm.is_main,
                            user_avatar: this.ruleForm.user_avatar,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '编辑成功',
                            duration: 1500,
                            onClose: function () {
                                // window.history.go(-1);
                                _that.is_submit = false;
                                window.history.go(-1);
                                return;
                            }
                        });
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },

        // 上传身份证正面图片
        handleUserAvatarImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.user_avatar = res.data;
                this.userAvaratImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },

        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png格式!');
            }
            if (!isLt5M) {
                isJPG = false;
                this.$message.error('图片大小不能超过5MB!');

            }
            return isJPG;
        },
        //选择图片
        selectImg(e) {
            let file = e.target.files[0]

            if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                this.$message({
                    message: '图片类型要求：jpeg、jpg、png',
                    type: "error"
                });
                return false
            }
            //转化为blob
            let reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                this.option.img = data

                this.dialogVisible = true;
            }
            //转化为base64
            reader.readAsDataURL(file)
        },
        //上传图片
        uploadImg(type) {
            let _this = this;
            if (type === 'blob') {
                //获取截图的blob数据
                this.$refs.cropper.getCropBlob(async (data) => {

                    let formData = new FormData();
                    formData.append('file', data, ".jpg")

                    await _this.$api.avatar_upload_file(formData).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code == 0) {
                            _this.ruleForm.user_avatar = res.data.data;
                            _this.userAvaratImageUrl = this.imgUrl + res.data.data;
                            _this.dialogVisible = false;
                        } else {
                            _this.$message({
                                type: "error",
                                message: res.data.msg,
                            });
                        }
                    })

                })
            }
        },
        // 关闭对话框清除之前选择的文件
        closeDialog() {
            document.getElementById('uploads').value = ''
            document.getElementById('suploads').value = ''
        },
        // 特属服务对象搜索
        getUser(key, cb) {
            if (key.indexOf('/') > -1) {
                this.prev_search = key.split('/')[1] || key.split('/')[0]
                key = this.prev_search
            }
            if (!key || this.search_key == key) {
                this.search_key = '';
                cb([{"value": "请输入特属服务对象关键词"}]);
                return;
            }
            this.search_key = key
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'searchUser',
                params: {
                    user_name: key,
                    assisitant_search: 1,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    return;
                }
                var users = res.data.data
                if (!users) {
                    return cb([{"value": "没有找到特属服务对象"}]);
                }
                for (var i = 0; i < users.length; i++) {
                    users[i].value = `${users[i].short_name}/${users[i].user_name}`
                }
                cb(users);
            });

        },
        userSelect(item) {
            this.ruleForm.client_id = item.user_id;
            this.ruleForm.user_info = item.user_name;
            this.old_user_name = this.ruleForm.user_info
        },
        resetUserInfo() {
            if (this.ruleForm.client_id) {
                this.ruleForm.user_info = this.old_user_name
            }
        },
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.cropper-content {
    .cropper {
        width: auto;
        height: 300px;
    }
}

.avatar-btn, .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-btn {
    display: inline-block;
    text-align: center;
}

.avatar-btn, .avatar-uploader .el-upload:hover {
    border-color: #d9d9d9;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar-btn {
    width: 200px;
    height: 200px;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.user_search {
    text-align: left;
    width: 100%;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
